import { TotalPrice } from '../../../components/PreviewResultLayout/components/TotalPrice';
import { ResultButtons } from '../../../components/PreviewResultLayout/components/ResultButtons';
import styles from './styles.module.scss';
import { ResultHeadline } from '../../../components/PreviewResultLayout/components/ResultHeadline';
import { ResultSubline } from '../../../components/PreviewResultLayout/components/ResultSubline';
import { useResultProps } from '../../../hooks/useResultProps';
import { useVariables } from 'src/processes/CMS/processes/management/pages/PreviewPage/hooks/useVariables';
import { Cards } from './components/Cards/Cards';
import { Progressbar } from '../../Sidebar/Progressbar';

// eslint-disable-next-line max-lines-per-function
export function PreviewResultLayout({
  resultObject,
  colors,
  fonts,
  style,
  allPages,
  setPagesFlow,
  pagesFlow,
  fontsForLoading,
  pageHistory,
  currentElements,
  setPageHistory,
  showChapterIds,
  chapterIconMedia,
  footer,
}) {
  const { applyVariable } = useVariables(pagesFlow);
  const { rootStyle = {}, headlineStyle = {}, sublineStyle = {}, buttonsStyle = {} } = style;

  const {
    content: { buttons },
  } = resultObject;

  const {
    headline,
    subline,
    sublineProps = {},
    headlineProps = {},
    printedResultProps = {},
    productInformation = {},
    totalPrice,
    resultProducts,
  } = useResultProps({
    allPages,
    resultObject,
    fonts,
    colors,
    headlineStyle,
    sublineStyle,
    pagesFlow,
    fontsForLoading,
    pageHistory,
    showChapterIds,
  });

  return (
    <section
      className={styles.section}
      style={{
        width: '100%',
        backgroundColor: colors?.backgroundColor,
      }}
    >
      <div className={styles.container} style={rootStyle}>
        <div className={styles.progressbarWrapper}>
          <Progressbar pagesFlow={pagesFlow} footer={footer} colors={colors} showChapterIds={showChapterIds} fonts={fonts} />
        </div>
        {headline && <ResultHeadline applyVariable={applyVariable} showInfoIcon {...headlineProps} />}
        {subline?.value && <ResultSubline applyVariable={applyVariable} showInfoIcon {...sublineProps} />}
        <Cards
          pagesFlow={pagesFlow}
          chapterIconMedia={chapterIconMedia}
          setPagesFlow={setPagesFlow}
          setPageHistory={setPageHistory}
          currentElements={currentElements}
          fonts={fonts}
          colors={colors}
          productInformation={productInformation}
          resultProducts={resultProducts}
        />
        {productInformation?.showTotalPrice && (
          <TotalPrice productInformation={productInformation} totalPrice={totalPrice} fonts={fonts} colors={colors} applyVariable={applyVariable} />
        )}
        <ResultButtons
          list={buttons.filter(button => pagesFlow.allShownButtonsIds.includes(button.id))}
          buttonsStyle={buttonsStyle}
          setPagesFlow={setPagesFlow}
          pagesFlow={pagesFlow}
          printedResultProps={printedResultProps}
          colors={colors}
          fonts={fonts}
          resultObject={resultObject}
          currentElements={currentElements}
          setPageHistory={setPageHistory}
        />
      </div>
    </section>
  );
}
